import { defineStore } from "pinia"

export const useAdminStore = defineStore("admin", {
  state: () => ({
    systemBanners: [],
    broadcasts: [],
    demoMode: null,
    demoAccounts: [],
    demoCatalog: null,
    loading: false,
    demoLoading: false,
    demoActionLoading: false,
  }),

  actions: {
    // System Banners
    async fetchSystemBanners() {
      this.loading = true
      try {
        const { data } = await this.$axios.get("/api/v1/notifications/system-banners")
        this.systemBanners = data.data
        return data
      } catch (error) {
        console.error("Failed to fetch system banners:", error)
        throw error
      } finally {
        this.loading = false
      }
    },

    async createSystemBanner(bannerData) {
      try {
        const { data } = await this.$axios.post("/api/v1/notifications/system-banners", bannerData)
        this.systemBanners.unshift(data.data)
        return data
      } catch (error) {
        console.error("Failed to create banner:", error)
        throw error
      }
    },

    async updateSystemBanner(id, bannerData) {
      try {
        const { data } = await this.$axios.put(`/api/v1/notifications/system-banners/${id}`, bannerData)
        const index = this.systemBanners.findIndex((b) => b.id === id)
        if (index !== -1) {
          this.systemBanners[index] = data.data
        }
        return data
      } catch (error) {
        console.error("Failed to update banner:", error)
        throw error
      }
    },

    async deleteSystemBanner(id) {
      try {
        await this.$axios.delete(`/api/v1/notifications/system-banners/${id}`)
        this.systemBanners = this.systemBanners.filter((b) => b.id !== id)
      } catch (error) {
        console.error("Failed to delete banner:", error)
        throw error
      }
    },

    // Broadcasts
    async fetchBroadcasts() {
      this.loading = true
      try {
        const { data } = await this.$axios.get("/api/v1/notifications/broadcasts")
        this.broadcasts = data.data
        return data
      } catch (error) {
        console.error("Failed to fetch broadcasts:", error)
        throw error
      } finally {
        this.loading = false
      }
    },

    async createBroadcast(broadcastData) {
      try {
        const { data } = await this.$axios.post("/api/v1/notifications/broadcasts", broadcastData)
        this.broadcasts.unshift(data.data)
        return data
      } catch (error) {
        console.error("Failed to create broadcast:", error)
        throw error
      }
    },

    async getBroadcastAnalytics(id) {
      try {
        const { data } = await this.$axios.get(`/api/v1/notifications/broadcasts/${id}/analytics`)
        return data.data
      } catch (error) {
        console.error("Failed to get analytics:", error)
        throw error
      }
    },

    async deleteBroadcast(id) {
      try {
        await this.$axios.delete(`/api/v1/notifications/broadcasts/${id}`)
        this.broadcasts = this.broadcasts.filter((b) => b.id !== id)
      } catch (error) {
        console.error("Failed to delete broadcast:", error)
        throw error
      }
    },

    async fetchDemoMode() {
      this.demoLoading = true
      try {
        const { data } = await this.$axios.get("/api/v1/admin/demo-mode")
        this.demoMode = data.data.mode
        this.demoAccounts = data.data.accounts || []
        this.demoCatalog = data.data.catalog || null
        return data.data
      } catch (error) {
        console.error("Failed to fetch demo mode:", error)
        throw error
      } finally {
        this.demoLoading = false
      }
    },

    async updateDemoMode(payload) {
      this.demoActionLoading = true
      try {
        const { data } = await this.$axios.put("/api/v1/admin/demo-mode", payload)
        this.demoMode = data.data
        return data.data
      } catch (error) {
        console.error("Failed to update demo mode:", error)
        throw error
      } finally {
        this.demoActionLoading = false
      }
    },

    async syncDemoMode(payload = {}) {
      this.demoActionLoading = true
      try {
        const { data } = await this.$axios.post("/api/v1/admin/demo-mode/sync", payload)
        await this.fetchDemoMode()
        return data.data
      } catch (error) {
        console.error("Failed to sync demo mode:", error)
        throw error
      } finally {
        this.demoActionLoading = false
      }
    },
  },
})
